var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBoxChecked = function SvgBoxChecked(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#292929",
    d: "M17.5 3.75v12.5a1.25 1.25 0 0 1-1.25 1.25h-5.625a.624.624 0 1 1 0-1.25h5.625V3.75H3.75v7.5a.625.625 0 1 1-1.25 0v-7.5A1.25 1.25 0 0 1 3.75 2.5h12.5a1.25 1.25 0 0 1 1.25 1.25m-7.683 8.308a.624.624 0 0 0-.884 0L5 15.99l-1.433-1.433a.624.624 0 1 0-.884.884l1.875 1.875a.626.626 0 0 0 .884 0l4.375-4.375a.626.626 0 0 0 0-.884"
  })));
};
export default SvgBoxChecked;